export const FETCH_PAYMENT_REFUNDS_REQUEST = 'FETCH_PAYMENT_REFUNDS_REQUEST';
export const FETCH_PAYMENT_REFUNDS_SUCCESS = 'FETCH_PAYMENT_REFUNDS_SUCCESS';
export const FETCH_PAYMENT_REFUNDS_FAILURE = 'FETCH_PAYMENT_REFUNDS_FAILURE';
export const FETCH_KYC_TOKEN_REQUEST = 'FETCH_KYC_TOKEN_REQUEST';
export const FETCH_KYC_TOKEN_SUCCESS = 'FETCH_KYC_TOKEN_SUCCESS';
export const FETCH_KYC_TOKEN_FAILURE = 'FETCH_KYC_TOKEN_FAILURE';
